<template>
  <div class="privacy-policy-summary">
    <h1 class="main-title">LumiMind隐私政策摘要</h1>
    <div class="content">
      <p>
        <strong>LumiMind</strong>（以下或称“我们”）非常注重保护用户（“您”）的个人信息及隐私，我们深知个人信息对您的重要性，本摘要旨在帮助您直观、简明地了解我们是如何收集、处理个人信息以及保护您的隐私。更多详情信息请阅读完整的<a href="https://app.neuroflux.com/#/policy/privacy">《LumiMind隐私政策》</a>。
      </p>
      <p><strong>1、为提供功能/服务收集使用的个人信息</strong></p>
      <p><strong>（1）功能/服务种类</strong>：注册和登录服务、账号状态异常识别</p>
      <p>个人信息/权限种类：手机号码、验证码、设备信息。</p>
      <p><strong>（2）功能/服务种类</strong>：设备连接和管理</p>
      <p>个人信息/权限种类：调用手机的蓝牙功能，扫描附近的蓝牙设备，并建立蓝牙连接。在部分手机系统中，由于系统限制，扫描蓝牙设备时需要申请定位权限。</p>
      <p><strong>（3）功能/服务种类</strong>：助眠功能</p>
      <p>个人信息/权限种类：脑电、心率、血氧、运动等传感器数据。</p>
      <p><strong>（4）功能/服务种类</strong>：客服服务、个人信息修改服务</p>
      <p>个人信息/权限种类：上传的照片及其他上传内容。</p>
      <p>（5）<strong>功能/服务种类</strong>：文本输入服务</p>
      <p>个人信息/权限种类：剪贴板权限。</p>
      <p><strong>（5）功能/服务种类</strong>：提醒服务</p>
      <p>个人信息/权限种类：系统通知权限。</p>
      <p>（6）<strong>功能/服务种类</strong>：产品适配性识别、优化产品质量</p>
      <p>个人信息/权限种类：设备信息、服务日志信息。</p>
      <p><strong>2、与第三方共享个人信息</strong></p>
      <p>
        仅为实现<a href="https://app.neuroflux.com/#/policy/privacy">《LumiMind隐私政策》</a>中声明的目的，我们的某些服务将委托由授权的合作伙伴提供，如技术支持服务。您需要在使用合作方产品或功能前仔细阅读合作方的用户协议和隐私政策再进行使用。我们仅会出于合法、正当、必要和诚信原则共享您的个人信息，并且只会共享服务所必要的个人信息。我们与第三方共享的个人信息的具体种类和目的，您可详见<a href="https://app.neuroflux.com/#/policy/third-party-sharing">《LumiMind第三方合作共享信息说明》</a>。
      </p>
      <p><strong>3、我们如何保护您的个人信息</strong></p>
      <p>
        我们已使用符合业界标准的安全防护措施，并将会尽最大努力抵御并处置各类信息安全的威胁，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失，为您的信息安全提供全方位保障。同时，我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律法规有强制的留存要求。
      </p>
      <p><strong>4、您的权利</strong></p>
      <p>您有权管理您的个人信息，包括访问、删除、更正您的个人信息，撤回您的授权、注销您的账号。您可以通过我们的App中提供的功能设置进行上述操作。详细操作您可查阅<a href="https://app.neuroflux.com/#/policy/privacy">《LumiMind隐私政策》</a>。</p>
      <p><strong>5、我们如何处理未成年人的个人信息</strong></p>
      <p>
        我们非常重视未成年人个人信息的保护。由于我们的产品主要面向成人，如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。请您和您的监护人阅读我们专门制定的<a href="https://app.neuroflux.com/#/policy/youth-protection">《青少年个人信息保护协议》</a>，并在指导下使用我们的服务。
      </p>
      <p><strong>6、为提供功能/服务申请使用的权限</strong></p>
      <p>我们将在您使用特定产品功能时，向您申请使用该功能所必须的权限，如您不同意开启该权限，请点击“不允许”，或您希望撤回授权的，您可在设备的设置功能中关闭您已授权的权限。拒绝或撤回该权限的申请仅将影响您对特定产品功能的使用。
      </p>
      <p><strong>LumiMind IOS版本权限列表</strong></p>
      <table>
        <thead>
          <tr>
            <th>
              <p><strong>设备权限</strong></p>
            </th>
            <th>
              <p><strong>使用目的</strong></p>
            </th>
            <th>
              <p><strong>是否询问</strong></p>
            </th>
            <th>
              <p><strong>是否可关闭</strong></p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>蓝牙权限</td>
            <td>用于接助眠仪设备、控制助眠仪的功能、睡眠仪固件升级</td>
            <td>是</td>
            <td>是</td>
          </tr>
          <tr>
            <td>访问相册权限</td>
            <td>读取照片用于更新用户头像、提交用户反馈</td>
            <td>是</td>
            <td>是</td>
          </tr>
        </tbody>
      </table>
      <p><strong>LumiMind Android版本权限列表</strong></p>
      <table>
        <thead>
          <tr>
            <th>
              <p><strong>设备权限</strong></p>
            </th>
            <th>
              <p><strong>使用目的</strong></p>
            </th>
            <th>
              <p><strong>是否询问</strong></p>
            </th>
            <th>
              <p><strong>是否可关闭</strong></p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>蓝牙权限</td>
            <td>用于接助眠仪设备、控制助眠仪的功能、睡眠仪固件升级</td>
            <td>是</td>
            <td>是</td>
          </tr>
          <tr>
            <td>定位权限</td>
            <td>部分系统中扫描蓝牙设备需要申请定位权限，用于接助眠仪设备、控制助眠仪的功能、传输睡眠数据</td>
            <td>是</td>
            <td>是</td>
          </tr>
          <tr>
            <td>访问相册权限</td>
            <td>读取照片用于更新用户头像、提交用户反馈</td>
            <td>是</td>
            <td>是</td>
          </tr>
          <tr>
            <td>访问手机存储</td>
            <td>部分系统中访问用户相册需要申请手机存储权限，用于更新用户头像、提交用户反馈</td>
            <td>是</td>
            <td>是</td>
          </tr>
        </tbody>
      </table>
      <p>我们申请使用上述权限的目的详见<a href="https://app.neuroflux.com/#/policy/privacy">《LumiMind隐私政策》</a>。</p>
      <p> </p>
    </div>
  </div>
</template>
<script>
import { getLinkUrl } from '@/utils/linkConfig'

export default {
  name: 'PrivacySummary',
  methods: {
    getLinkUrl
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/zh-CN/PrivacySummary.vue